import React, { useState, useEffect } from "react";

import {connect} from 'react-redux';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { Link } from 'react-router-dom';
import FavouriteButton from '../../elements/songElements/favouriteButton';
import DownloadAllButton from '../../elements/songElements/downloadAllButton';
import SongToggleButton from '../../elements/songElements/songToggleButton';
import PlayPauseButton from '../../elements/songElements/playPauseButton';
import SongVersion from './songVersion';
import PlaylistPopup from './playlistPopup';

import * as actions from '../../store/customer/actions';


const  FavouriteSongTrack = ({songs, sectionName, displayDates}) => {

    
    const [toggleSong, setToggleSong ] = useState(false);
    const [activeSongId, setActiveSongId] = useState(0);



    
    useEffect(() => { 

    },[]);

    const setSongToggle = (songId) => {
        
        if(activeSongId == songId ){
            setToggleSong(!toggleSong)
        } else {
            setToggleSong(true)
        }
        setActiveSongId(songId)
    }


    

    return (
        <div className="play-list">
        {
            songs && songs.length > 0 ? 
                songs.map((song, index)=>{
                    return <div className={toggleSong && activeSongId == song.entity_id ? "block active" : "block"} key={`song${sectionName}${song.entity_id}`}>
                                <div className="play-track" onClick={() => setSongToggle(song.entity_id)}>
                                    <PlayPauseButton parentComponent="songTrack" song={song} />
                                    <div className="track-name">
                                        <span className="text-2" dangerouslySetInnerHTML={{__html: song.title}}></span>
                                        {/* <span className="text-5" dangerouslySetInnerHTML={{__html: song.artist}}></span> */}
                                        <div className="artist-name">
                                        { 
                                            song.artist_search && song.artist_search[0].artist && song.artist_search[0].artist.length > 0 ? 
                                                song.artist_search[0].artist.map((as, asIndex) => {
                                                    return <div key={`as${asIndex}-${song.entity_id}`} ><Link to={`/mp3/artist/${as}`} dangerouslySetInnerHTML={{__html: as}} className="text-5"></Link> <span className="text-5">&nbsp;{ asIndex < (song.artist_search[0].artist.length -1) ? song.artist_search[0].split_string : ''}&nbsp;</span></div>
                                                })
                                            :
                                            <div className="artist-name"><Link to={`/mp3/artist/${song.artist}`} dangerouslySetInnerHTML={{__html: song.artist}} className="text-5"></Link></div>
                                        }
                                        </div>
                                    </div>
                                </div>
                                <div className="play-track-content">
                                    <div>
                                        <span className="text-5">{song.max_bpm}</span>
                                        <span className="text-4">{song.song_key}</span>
                                        { displayDates ? <span className="text-5">{song.created_at}</span> : '' }
                                    </div>
                                    {/* <div className="divider">
                                        <InfoButton song={song} />
                                        <GenresInfoButton song={song} />
                                    </div> */}
                                    <div className="divider">
                                        <FavouriteButton song={song} />
                                        <DownloadAllButton entity_id={song.entity_id} />
                                        <PlaylistPopup song={song} />
                                    </div>
                                    <div>
                                        <SongToggleButton songId={song.entity_id} setSongToggle={setSongToggle} toggleSong={toggleSong}  />
                                    </div>
                                </div>
                                <div className="version-container">
                                {
                                    song.version && song.version.length > 0 ?
                                        song.version.map((version, index) => {
                                            return <div className='block-inner-content' key={`song${sectionName}version${song.entity_id}${version.song_version_id}`}>
                                                <SongVersion version={version} songId={song.entity_id} songSectionId={song.song_section_id} song={song} />
                                            </div>
                                        })
                                    : ''
                                }
                                </div>
                                  
                            </div>
                    })
            : ''
        }
        </div>
    );
  
}


function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    playlistAlbums: state.customer.playlistAlbums,
    userProfile: state.customer.customerProfile,
  };
 }
 
 function mapDispatchToProps(dispatch) {
  return {
    displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
    hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar))
  };
 }

export default connect(mapStateToProps, mapDispatchToProps)(FavouriteSongTrack);
